/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const _ = require("lodash");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(activity, "description.description", `Policy created by user (${activityEntity.createdBy}).`);
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let patch = activityEntity.getProperty("patch");
        if (!patch || _.isEmpty(patch)) {
            return;
        }
        let description,
            updatedBy = _.get(activityEntity, "createdBy", _.get(activityEntity, "before.updatedBy", "system")),
            activityType = updatedBy === "system" ? "system" : "note",
            activityStatus = "clean",
            status = _.get(_.find(patch, { path: "/lastAuditStatus" }), "value");

        switch (status) {
            case "SUCCESSFUL":
                let dCnt = _.get(_.find(patch, { path: "/lastAuditDeviceCount" }), "value", 0);
                let vdCnt = _.get(_.find(patch, { path: "/lastAuditDevicesInViolationCount" }), "value", 0);
                let eCnt = _.get(_.find(patch, { path: "/lastAuditDeviceErrorCount" }), "value", 0);
                description = `Audit completed for ${dCnt} Devices with ${eCnt} errors. There were ${vdCnt} devices with one or more violations.`;
                activityStatus = "success";
                break;
            case "FAILED":
                let errMsg = _.get(_.find(patch, { path: "/lastAuditErrorMsg" }), "value");
                description = `Audit failed during execution with "${errMsg}".`;
                activityStatus = "failed";
                break;
            case "RUNNING":
                description = `Audit running.`;
                activityStatus = "running";
                break;
            default:
                description = `Policy updated by user (${updatedBy}).`;
                break;
        }

        if (description) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityType);
            _.set(activity, "description.description", description);
            _.set(activity, "status", activityStatus);
            return activity;
        }
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.getProperty("activityType");
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            case "relAdd":
                let createdBy = _.get(activityEntity, "createdBy", "unknown");
                activity = {};
                _.set(activity, "activityType.activityType", activityType);
                _.set(activity, "description.description", `Audit Started by (${createdBy}).`);
                _.set(activity, "status", "started");
                break;
        }
        if (!_.isEmpty(activity)) {
            let date = new Date(activityEntity.createdOn).toLocaleDateString() + " " + new Date(activityEntity.createdOn).toLocaleTimeString();

            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
